import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { PageInfo } from 'src/app/shared/models/queryparams/pageinfo.model';
import { SortInfo } from 'src/app/shared/models/queryparams/sortinfo.model';
import { ToastService } from 'src/app/shared/services/toast.service';
import { GetUserPermissionList } from 'src/app/state';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { State } from 'src/app/state/app.state';
import { ITenantGridData } from '../shared/models/tenant_grid_data.model';
import { TenantGridParams } from '../shared/models/tenant_grid_params.model';
import { TenantService } from '../shared/services/tenant.service';

declare const window: any;
@Component({
  selector: 'app-tenant-grid',
  templateUrl: './tenant-grid.component.html',
  styleUrls: ['./tenant-grid.component.scss']
})

export class TenantGridComponent implements OnInit {

  tenantGridSource: ITenantGridData[] = [];
  tenantGridData: ITenantGridData[] = [];
  pageInfo: PageInfo = {
    Page: 1,
    PageSize: 25
  };
  searchTextValue: string = '';
  showPopUp: boolean = false;
  userPermissionList: number[] = [];

  public sort: SortDescriptor[] = [{
    field: 'tenantCode',
    dir: 'asc'
  }];

  public tenantGridForm: FormGroup = new FormGroup({
    searchClient: new FormControl('')
  });

  constructor(private tenantService: TenantService,
    private router: Router,
    private toastService: ToastService,
    private store: Store<State>,
    private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (allUserPermissions) {
        this.userPermissionList = allUserPermissions;
      }
    });
    this.getTenantGridData();
  }

  private getGridParams(): TenantGridParams {
    const tenantGridParams = new TenantGridParams();
    tenantGridParams.pageInfo = new PageInfo();
    tenantGridParams.pageInfo.Page = 1;
    tenantGridParams.pageInfo.PageSize = 10;
    tenantGridParams.sortInfo = new SortInfo();
    tenantGridParams.sortInfo.SortColumn = 'tenantCode';
    tenantGridParams.sortInfo.sortDirection = 1;
    tenantGridParams.searchText = '';
    return tenantGridParams;
  }

  /*
  * Get tenant data for tenant grid
  */
  getTenantGridData() {
    this.tenantService.getTenantsGrid()
      .subscribe((response: ITenantGridData[]) => {
        this.tenantGridSource = response;
        this.tenantGridData = response;
      },
        (err) => {
          this.handleError(err, '_Clients_Retrieving_Client_Grid_Data_Failed_Ts_Text_')
        });
  }

  /*
  * Go to add client page
  */
  goToTenantCreation() {
    // this.tenantService.editTenant = null;
    this.router.navigate(['admin/tenant/tenant-creation']);
  }

  /*
  * Search client by code, name, solution id, server name or database name
  */
  search() {
    const searchText = this.tenantGridForm.controls.searchClient.value.toLowerCase();
    if (searchText) {
      // initialize the tenantGridSource again,
      // otherwise, for an empty-result search, the previous tenantGridSource collection is retained and displayed
      this.tenantGridSource = [];

      const filteredDataSource = this.tenantGridData.filter(t =>
        t.tenantCode.toLowerCase().includes(searchText)
        || t.tenantName.toLowerCase().includes(searchText)
        || t.databaseName.toLowerCase().includes(searchText)
        || t.serverName.toLowerCase().includes(searchText)
        || t.solutionId.toLowerCase().includes(searchText));
      this.tenantGridSource = filteredDataSource;
    }
    else {
      this.tenantGridSource = this.tenantGridData;
    }

    if (this.pageInfo) {
      this.pageInfo.Page = 1;
    }
  }

  /**
  * Triggers when user click the clear search button.
  *  
  */
  public onClearSearchTextClicked() {
    this.searchTextValue = '';
    this.tenantGridSource = this.tenantGridData;

    if (this.pageInfo) {
      this.pageInfo.Page = 1;
    }
  }

  handleError(err: any, errorMessage: string) {
    console.log(err);
    this.toastService.showError(errorMessage);
  }

  showSuccessToast(successMessage: string) {
    this.toastService.showSuccess(successMessage);
  }

  public onPageChange(event: PageChangeEvent) {
    if (this.pageInfo) {
      this.pageInfo.Page = (event.skip / this.pageInfo.PageSize) + 1;
    }
  }
}
